import { createSelector } from 'reselect';
import PaperFreeMonitoringCarrierSummaryColumns
  from '../../containers/PaperFreeMonitoringCarrierSummaryColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .PAPER_FREE_MONITORING_CARRIER_901_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .PAPER_FREE_MONITORING_CARRIER_901_SUMMARY.isLoading;

export const getData =
  ReportDefinitions
    .PAPER_FREE_MONITORING_CARRIER_901_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, PaperFreeMonitoringCarrierSummaryColumns);
